import { render, staticRenderFns } from "./DetailedPricingWall.vue?vue&type=template&id=881f365c&scoped=true"
import script from "./DetailedPricingWall.vue?vue&type=script&lang=js"
export * from "./DetailedPricingWall.vue?vue&type=script&lang=js"
import style0 from "./DetailedPricingWall.vue?vue&type=style&index=0&id=881f365c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881f365c",
  null
  
)

export default component.exports